<template>
	<v-app-bar absolute color="primary" elevation="0" class="text-center px-2 py-1 auth-health-bar">
		<span class="d-flex ga-2 mx-auto text-white font-weight-bold align-center justify-center auth-health-bar-content">
			<v-icon class="d-flex" color="white">icon-info-circle-stroke</v-icon>
			<span class="auth-health-bar-label">Some Apps need to be reconnected</span>
			<v-btn
				variant="outlined"
				color="white"
				size="small"
				rounded="xl"
				class="ml-2 text-none auth-health-bar-button"
				@click="$emit('show-all')">
				View All
			</v-btn>
		</span>
	</v-app-bar>
</template>

<script setup lang="ts">
	defineEmits<{
		(e: "show-all"): void;
	}>();
</script>

<style scoped>
	.auth-health-bar :deep(.v-toolbar__content) {
		height: auto !important;
		min-height: 52px !important;
	}

	.auth-health-bar {
		height: auto !important;
		min-height: 52px;
	}

	.auth-health-bar-content {
		flex-wrap: wrap;
	}

	.auth-health-bar-label {
		line-height: 1.3;
		word-break: break-word;
	}

	@media (max-width: 600px) {
		.auth-health-bar-button {
			margin-left: 0 !important;
		}
	}
</style>
